import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { usePeopleConnections } from "../../../api/queries/people-connection/usePeopleConnections";
import { useTriggerCheckIn } from "../../../api/queries/people-connection/useTriggerCheckIn";
import {
  PeopleConnectionItem,
  PeopleConnectionStatus,
} from "../../../api/types/people-connection";

export default function PeopleConnectionList() {
  const { data: connections, isLoading, refetch } = usePeopleConnections();
  const triggerCheckIn = useTriggerCheckIn();
  const [processingId, setProcessingId] = useState<string | null>(null);

  const handleTriggerCheckIn = async (itemId: string) => {
    setProcessingId(itemId);
    try {
      await triggerCheckIn.mutateAsync(itemId);
      refetch();
    } finally {
      setProcessingId(null);
    }
  };

  const actionTemplate = (rowData: PeopleConnectionItem) => {
    if (rowData.status !== PeopleConnectionStatus.APPROVED) {
      return null;
    }

    return (
      <Button
        label="Trigger Check-in"
        icon="pi pi-send"
        onClick={() => handleTriggerCheckIn(rowData.id)}
        loading={triggerCheckIn.isLoading && processingId === rowData.id}
        disabled={triggerCheckIn.isLoading}
        size="small"
      />
    );
  };

  const statusTemplate = (rowData: PeopleConnectionItem) => {
    return (
      <span className={`badge badge-${rowData.status}`}>{rowData.status}</span>
    );
  };

  const feedbackTemplate = (rowData: PeopleConnectionItem) => {
    if (!rowData.feedback || rowData.feedback.length === 0) {
      return <span className="text-muted">No feedback</span>;
    }
    const latest = rowData.feedback[rowData.feedback.length - 1];
    return (
      <span>
        {latest.value} ({new Date(latest.timestamp).toLocaleDateString()})
      </span>
    );
  };

  const checkInTemplate = (rowData: PeopleConnectionItem) => {
    return rowData.checkInSentAt ? (
      new Date(rowData.checkInSentAt).toLocaleString()
    ) : (
      <span className="text-muted">Not sent</span>
    );
  };

  return (
    <div className="col-12">
      <div className="flex py-3">
        <h1 className="m-0">People Connection Management</h1>
      </div>

      <DataTable
        value={connections?.data || []}
        loading={isLoading}
        paginator
        rows={25}
        emptyMessage="No connections found"
        className="p-datatable-sm"
        stripedRows
      >
        <Column field="name" header="Name" sortable />
        <Column field="email" header="Email" sortable />
        <Column field="status" header="Status" body={statusTemplate} sortable />
        <Column header="Feedback" body={feedbackTemplate} />
        <Column header="Check-in Sent" body={checkInTemplate} sortable />
        <Column header="Actions" body={actionTemplate} />
      </DataTable>
    </div>
  );
}
